import { useQuery } from "@apollo/client";
import Markdown from "markdown-to-jsx";
import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import React from "react";
import Box from "../components/Box";
import ShopLayout from "../components/layouts/ShopLayout";
import Title from "../components/Title";
import { footerQuery, headerQuery, pageQuery } from "../graphql/queries";
import { PageBySlugQuery, PageBySlugQueryVariables } from "../graphql/types";
import { getStringFromQuery } from "../helpers/url";
import { initializeApollo } from "../libs/apollo-client";

const StrapiPage = () => {
  const { query } = useRouter();

  const { data } = useQuery<PageBySlugQuery, PageBySlugQueryVariables>(
    pageQuery,
    {
      variables: {
        slug: getStringFromQuery(query.slug),
      },
    }
  );

  return (
    <ShopLayout
      title={data?.pageBySlug.seo?.metaTitle}
      metaDescription={data?.pageBySlug.seo?.metaDescription}
    >
      <Box mx={3} my={5}>
        <Title level={2} css={{ textAlign: "center" }}>{data?.pageBySlug.title}</Title>
        <Markdown>{data?.pageBySlug.content || ""}</Markdown>
      </Box>
    </ShopLayout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  query,
}) => {
  const apolloClient = initializeApollo(null, locale);
  await apolloClient.query({
    query: footerQuery,
  });
  await apolloClient.query({
    query: headerQuery
  });
  try {
    await apolloClient.query({
      query: pageQuery,
      variables: {
        slug: getStringFromQuery(query.slug),
      },
    });
  } catch (e) {
    return { notFound: true };
  }

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
      ...(await serverSideTranslations(locale as string)),
    },
  };
};

export default StrapiPage;
